import { action, observable } from 'mobx';
import { applyTo, omit } from 'ramda';

import { Kinesis } from '../services/TrackerService';
import { ILogFields } from '../services/TrackerService/Kinesis/interfaces';

interface ILogData extends Omit<ILogFields, 'eventType'> {}

export default class ImpressionStore {
  @observable
  logHistory = {};

  @action.bound
  recordLog(id, logData): void {
    this.logHistory[id] = logData;
  }

  @action.bound
  isLogged(id: string | number): boolean {
    return !!this.logHistory[id];
  }

  @action.bound
  onBeforeUnload(generateLogDataFn): void {
    window.addEventListener('beforeunload', () => {
      const applyToLog = applyTo(this.logHistory);
      const logData: ILogData = applyToLog(generateLogDataFn);

      if (logData && logData.pageName) {
        Kinesis.impression(logData.pageName, omit(['pageName'], logData));
      }
    });
  }
}
